var rich_content_viewer_default = {
  "fontElementMap": "CN4iQ",
  "wrapper": "gE0qw",
  "pluginContainerMobile": "WHU1u",
  "viewer": "kniD-",
  "android": "Xmfho",
  "rootedTraversedContent": "Qxk9I",
  "atomic": "_4yHot",
  "toolbar": "owU7Y",
  "block": "_0FP7v"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
